import React from 'react'
import Navbar from '../components/common/Navbar'
import MedicineJourney from '../components/Hero-Section'

const Home = () => {
  return (
    <div>
        <Navbar/>
        <MedicineJourney/>
    </div>
  )
}

export default Home